import LegalPage from "../../components/LegalPage/LegalPage";
import { termsAndConditions } from "../../constants/termsAndConditions";

const TermsAndConditionsPage = () => (
  <LegalPage title="Terms & Conditions" content={termsAndConditions} />
);

export default TermsAndConditionsPage;
